var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavePlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 212,
    viewBox: "0 0 212 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17491_97126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3825 -12.9165L121.439 -18.4771L228.858 89.053L223.283 147.264L63.3825 -12.9165Z",
    fill: "url(#paint0_linear_17491_97126)",
    fillOpacity: 0.4,
    stroke: "url(#paint1_linear_17491_97126)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17491_97126",
    x1: 221,
    y1: 27,
    x2: 110,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE27F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17491_97126",
    x1: 221,
    y1: 27,
    x2: 110,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE27F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17491_97126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 212,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavePlat);
export default __webpack_public_path__ + "static/media/savePlat.56105b2b3c33d88214b1bee434622725.svg";
export { ForwardRef as ReactComponent };